module.exports = __webpack_public_path__ + "img/Task2Do_Logo_2020-03-09_750x150.7620dde7.png";